import {Input} from "reactstrap";
import i18n from "../../../../lib/utils/i18n";
import {useApi} from "../../../../lib/api/useApi";
import "./style.css";
import {LANGUAGE, OTHER_LANGUAGES} from "../../../../lib/utils/constants";

const Index = () => {
    const {updateGlobalState} = useApi();
    const { language } = i18n;

    const appLanguage = LANGUAGE.toLocaleLowerCase();
    const appOtherLanguages = OTHER_LANGUAGES.toLocaleLowerCase();

    const switchLanguage = (language) => {
        const {value} = language.target;
        i18n.changeLanguage(value).then(() => updateGlobalState({value}));
    }

    return <Input type="select" name="languageSwitch" className="languageSwitch" defaultValue={language}
                  onChange={switchLanguage}>
        <option value={appLanguage}>{appLanguage}</option>
        <option value={appOtherLanguages}>{appOtherLanguages}</option>
    </Input>
}

export default Index